import {Tooltip} from "@material-ui/core"
import React from "react"

function EmailStatusIcon({title = "", icon = ""}: {title?: string; icon?: string}) {
	return (
		<Tooltip title={title}>
			<span> {icon}</span>
		</Tooltip>
	)
}

export {EmailStatusIcon}
